import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";

export default function AgencyRegister() {
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const [form, setForm] = useState({
    agency_name: "", city: "", state: "SC",
    admin_name: "", admin_email: "", admin_phone: "", admin_password: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/agency/register", form);
      setAuth(data.token, data.user);
      toast.success(`Imobiliária ${form.agency_name} cadastrada!`);
      navigate("/imobiliaria");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao cadastrar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#071129] text-white flex flex-col">
      <div className="p-5 lg:px-10">
        <Link to="/" className="text-white/60 hover:text-white text-sm inline-flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center p-5 lg:p-10">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-xl bg-[#3B9EFF]/15 border border-[#3B9EFF]/30 flex items-center justify-center">
              <Building2 className="w-6 h-6 text-[#3B9EFF]" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#3B9EFF] font-bold">Sou imobiliária</div>
              <h1 className="font-heading text-2xl font-extrabold">Cadastre sua imobiliária</h1>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="agency_name" className="text-white/80">Nome da imobiliária</Label>
              <Input id="agency_name" data-testid="agency-name-input" required value={form.agency_name} onChange={(e) => set("agency_name", e.target.value)}
                className="!bg-white/10 !text-white !border-white/20 placeholder:!text-white/40" placeholder="Ex: Donna SC" />
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div className="col-span-2">
                <Label htmlFor="city" className="text-white/80">Cidade</Label>
                <Input id="city" data-testid="agency-city-input" required value={form.city} onChange={(e) => set("city", e.target.value)} className="!bg-white/10 !text-white !border-white/20 placeholder:!text-white/40" />
              </div>
              <div>
                <Label htmlFor="state" className="text-white/80">UF</Label>
                <Input id="state" data-testid="agency-state-input" required maxLength={2} value={form.state} onChange={(e) => set("state", e.target.value.toUpperCase())} className="!bg-white/10 !text-white !border-white/20 placeholder:!text-white/40" />
              </div>
            </div>
            <div className="pt-3 border-t border-white/10">
              <div className="text-xs uppercase tracking-wider text-white/50 font-semibold mb-3">Seus dados de acesso (gestor)</div>
            </div>
            <div>
              <Label htmlFor="admin_name" className="text-white/80">Seu nome</Label>
              <Input id="admin_name" data-testid="agency-admin-name-input" required value={form.admin_name} onChange={(e) => set("admin_name", e.target.value)} className="!bg-white/10 !text-white !border-white/20 placeholder:!text-white/40" />
            </div>
            <div>
              <Label htmlFor="admin_email" className="text-white/80">E-mail</Label>
              <Input id="admin_email" data-testid="agency-admin-email-input" type="email" required value={form.admin_email} onChange={(e) => set("admin_email", e.target.value)} className="!bg-white/10 !text-white !border-white/20 placeholder:!text-white/40" />
            </div>
            <div>
              <Label htmlFor="admin_phone" className="text-white/80">WhatsApp (com DDD)</Label>
              <Input id="admin_phone" data-testid="agency-admin-phone-input" required value={form.admin_phone} onChange={(e) => set("admin_phone", e.target.value)} placeholder="48 99999-9999" className="!bg-white/10 !text-white !border-white/20 placeholder:!text-white/40" />
            </div>
            <div>
              <Label htmlFor="admin_password" className="text-white/80">Senha</Label>
              <Input id="admin_password" data-testid="agency-admin-password-input" type="password" required minLength={6} value={form.admin_password} onChange={(e) => set("admin_password", e.target.value)} className="!bg-white/10 !text-white !border-white/20 placeholder:!text-white/40" />
            </div>
            <Button type="submit" data-testid="agency-register-submit" disabled={loading}
              className="w-full bg-[#3B9EFF] hover:bg-[#1F7CE0] text-white py-6 rounded-full font-semibold">
              {loading ? "Cadastrando..." : "Cadastrar imobiliária"}
            </Button>
            <p className="text-xs text-white/50 text-center">
              Ao cadastrar você pode adicionar até 30 corretores no piloto. Sem cobrança nos 30 primeiros dias.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
